import { Component, Input, OnInit,ChangeDetectorRef,ViewChild,ElementRef } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../../Interfaces/JSONRpcResponse'
import { CourbeService, DialogService, StateService } from '../../../../../../services'
import { ConfirmComponent } from "../../../../../partials/layout/dialogs/confirm-dialog/confirm.component"
import { CourrierDialog } from '../../../../../partials/layout/dialogs/courrier-dialog/courrier-dialog.component'
import { SuiviListing } from '../../../../../partials/content/listing/suivi-listing/suivi-listing.component'
import { FormulaireSuiviListing } from '../../../../../partials/content/listing/formulaire-suivi-listing/formulaire-suivi-listing.component'
import { InstructionListing } from '../../../../../partials/content/listing/instruction-listing/instruction-listing.component'
import { of,Observable, Subject,  } from 'rxjs'
import { Chart,ChartType } from 'chart.js';
import { FormDialogFormulaireWithSFComponent } from '../../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { PrintDialog } from '../../../../../partials/layout/dialogs/print-dialog/print-dialog.component'
import { LoadDialogComponent } from '../../../../../partials/layout/dialogs/load-dialog/load.component'



const KEY = "courbe"

@Component({
    selector: 'atyl-courbe',
    templateUrl: './courbe.component.html',
    styleUrls: ['./courbe.component.scss']
})
@Stringable({
    path: "views/pages/recherche/tabs/courbe",
    key: KEY,
})
export class CourbeComponent implements OnInit {
    @StringableValues(KEY) strings: any
    @Input() eventLoad: Observable<boolean>;
    loading: boolean = false;
    @Input() courbe: any;
     @Input() dossier: any;
     @Input() filters: any;
     
   
    selectCourbeIndex:number=0;
    datasets:any[]=[];
    
   @ViewChild('chart', { static: false }) chart: ElementRef;
   
   /*
   <google-chart 
 [title]="gchart.title"
 [type]="gchart.type" 
  [data]="gchart.data"
 [columns]="gchart.columnNames" 
 [options]="gchart.options">
</google-chart>
   */
   height:string="70vh";
   
   gchart:any = {
	   data : [
		   
		],
	   type :'LineChart',
	   title  : '',
	   columnNames : [""],
	   options : {
	   		/*chartArea:{left:0,top:0,width:"100%",height:"100%"},*/
	   		width:'500',
	   		height:'400',
	   		/* width:'100%',
			  width_units: '%',
			 height: '100%',
			  height_units : '%'*/
		}
				 
   }
   mychart:any;
   
    constructor(
        private courbeService: CourbeService,
        private stateService: StateService,
        private dialogService: DialogService,
        private changeDetectorRef: ChangeDetectorRef,
    ) { }

    ngOnInit() {

        
      // this.initChart();
       	
		 
        this.eventLoad.subscribe((loading:boolean) => {
	         
	         this.loadChart(true);
		});
        
       
		 
	}
	
	loadChart(loading:boolean) {
		this.loading=loading;
			  let _ops={
		       		filters: this.filters
				}
	         this.courbeService.get(this.courbe.key, this.dossier.ID,true,_ops).subscribe(
				(res: JSONRpcResponse) => {
					
					if (res.result) {
						 
						this.courbe=res.result;
						
						
						console.log("my chat",this.courbe)	;
						this.datasets=[];
						let labels:any[]=[];
						for(let i:number=0;i<this.courbe.series.length;i++) {
							let serie:any=this.courbe.series[i];
							
							//if (i==0) {
								//console.log("serie",serie);
								let _dataset=(serie.parametre) ? serie.parametre : {};
								_dataset["label"]=serie.libelle;
								if (this.courbe.type_charjs=="line"
								 || this.courbe.type_charjs=="scatter"
								 || this.courbe.type_charjs=="bubble"
								 ) {
									if (serie.ydata)
									   _dataset["data"]=serie.ydata;
								} else {
									let lbs=[];
									let dts=[];
									let dats=this.courbe.datas.datas[i];
									labels=this.courbe.datas.labels;
									//console.log("serie data",dats);
									for(let j:number=0;j<dats.length;j++) {
										let elt:any=dats[j];
										//console.log("elt ",elt)
										if (elt.y!=undefined) 
											dts.push(elt.y);
									    else
									      dts.push("");
									}
									_dataset["data"]=dts;
									//_dataset["labels"]=lbs;
									
								}  
								this.datasets.push(_dataset);
							//}	
							/* this.datasets.push(serie.ydata);*/
						}
					
						
					this.mychart.data.datasets=	this.datasets;
					
					
					
					
				if (labels.length>0)
					 this.mychart.data.labels=labels;
				
				
				
					/*this.gchart.data=this.datasets;*/
					/*this.gchart.data=this.courbe.data;*/
				
					console.log("my chat",this.datasets,this.mychart)	;
						
					this.loading=false;
					this.changeDetectorRef.detectChanges();
					this.mychart.update();	
				}
				}
			);
			
	  
	}
	
	initChart() {
		
		let _options={
				parsing: false,
				
				responsive: true,
				maintainAspectRatio: false,
				scales: {
			            xAxes: [{
			                type: 'linear',
			                position: 'bottom'
			            }]
					},
				title: {
					          display: true,
					          text: this.courbe.libelle
					        },
					        legend: {
					          display : false
					        }
				};
			
		if (this.courbe.parametre) { 
			var jsonData:any = this.courbe.parametre;
			if (jsonData["hasJsfunction"]!=undefined && jsonData["hasJsfunction"])
				this.Iterate(jsonData);
		    _options= jsonData;
			if (jsonData["height"]!=undefined && jsonData["height"])
				this.height=jsonData["height"];
				
		}
		console.log("chart",this.courbe,this.height)
		
		this.mychart = new Chart(this.chart.nativeElement, {
							      type : this.courbe.type_charjs,
							     /* data:{
								     datasets: this.datasets,
							      
							      },*/
							      options: _options		
										
							        
		});
		
	}
	
	ngAfterViewInit() {
		
		this.initChart();
		this.loadChart(true);
		this.changeDetectorRef.detectChanges();
		
		
	}
	
    Iterate(obj:any)
	{
	     for (var property in obj) {
			 if (typeof obj[property] == 'object') {
	            this.Iterate(obj[property]);
	        } else {
				if (Array.isArray(obj[property])) {
					let myarray:any[]=[];
					for(let i=0;i<obj[property].length;i++) {
						myarray.push(this.Iterate(property[i]));
					
					}
					obj[property]=myarray;
				} else {
					//console.log('Iterate',obj,property,obj[property])
					 if (obj[property]!=undefined 
					 && typeof obj[property] == 'string'
					 && obj[property]  
					 && obj[property].indexOf("function(") > -1) {
		                obj[property] = eval("(" + obj[property] + ")");
					}
				}
		 	}
		 }
	     /*
	      data.forEach(function (index:any, value:any) {
	        if (typeof value == 'object') {
	            this.Iterate(value);
	        }
	        else {
	            if (value.indexOf("function(") > -1)
	                data[index] = eval("(" + value + ")");
	        }
	    });*/
	
	};
	
	initGChart() {
		this.gchart.type=this.courbe.type_gchart;
		this.gchart.title=this.courbe.libelle;
		this.gchart.data=this.courbe.data;
		
		if (this.courbe.parametre)
		  this.gchart.options=this.courbe.parametre;
		
		let cln:string[]=["X"];
		for(let i:number=0;i<this.courbe.series.length;i++) {
			let serie:any=this.courbe.series[i];
			cln.push(serie.libelle);
		}
		this.gchart.columnNames=cln;
		
	}
    
    export() {
		if (this.mychart) {
			
			let image:any = this.mychart.toBase64Image();
			 let _ops={
		       		filters: this.filters
				}
	         this.courbeService.export(this.courbe.key, this.dossier.ID,image,_ops).subscribe(
				(res: JSONRpcResponse) => {
					console.log('export chart',res)
					if (res.result
						 && res.result.print) {
						
						// window.open(res.result.print.url, ' _blank')
						 const dial=this.dialogService.open(LoadDialogComponent, {
									               data: {
									                   url: res.result.print.url
									               },
												   height: "95vh",
												   width: "80%",
												   minimizable: true,
												   maximizable: true,
												   draggable: true,
									           }, (res: any) => {
									               
					})
					}
				}
				);
		}	
	
	}
	
	newForm(form:any) {
		console.log("newForm",form);
		
		const dialogRef=this.dialogService.open(
            FormDialogFormulaireWithSFComponent,
            {
                data: {
                    idAForm: form.ID,
                    dossier: this.dossier,
                    create: true,
                    closeWhenValidate: true,
                    
                    v3: true,
                },
                height: "90vh",
                width: "90vw",
                draggable: true,
                resizable: true,
                minimizable: true,
                maximizable: true,
            })
            
            dialogRef.afterClosed().subscribe(result => {
                    if(result){
                    this.loadChart(true);
                   this.changeDetectorRef.detectChanges();
                   
                    }
              });
		
	}
	
	openForm(df:any) {
		console.log("newForm",df);
		
		let datasF = {
					title: df.form.libelle,
					id: df.ID,
					formType: df.form.key,
					idDemandeForm: df.form.ID,
					
					
					
				}
		datasF['dossier'] = this.dossier
		datasF['isEditable'] = true;
	           
		const dialogRef=this.dialogService.open(FormDialogFormulaireWithSFComponent, {
			data: datasF,
			height: '90vh',
			width: "90vw",
			resizable: true,
			minimizable: true,
			draggable: true,
			maximizable: true,
		});
            
       dialogRef.afterClosed().subscribe(result => {
                    if(result){
                    this.loadChart(true);
                   this.changeDetectorRef.detectChanges();
                   
                    }
              });     
		
	}

   printform(df:any) {
	    this.dialogService.open(PrintDialog, {
            data: {
                formulaire: df,
                dossier: this.dossier,
                
            },
            draggable: false,
            resizable: false,
        });
   }
    

}




